import { render, staticRenderFns } from "./ProductFileComponent.vue?vue&type=template&id=04492c41"
import script from "./ProductFileComponent.vue?vue&type=script&lang=js"
export * from "./ProductFileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports